(() => {
  'use strict';
  if (window.NordicwoodsAttribution) return;
  const key = 'nw_ai_visit_v1';
  const lifetime = 30 * 60 * 1000;
  const hosts = new Set(['chatgpt.com', 'www.chatgpt.com', 'chat.openai.com', 'perplexity.ai', 'www.perplexity.ai', 'claude.ai', 'gemini.google.com', 'copilot.microsoft.com', 'grok.com', 'www.grok.com', 'chat.mistral.ai', 'lechat.mistral.ai', 'poe.com', 'www.poe.com', 'you.com', 'www.you.com']);
  const sources = {
    'chatgpt': 'chatgpt.com', 'chatgpt.com': 'chatgpt.com', 'chat.openai.com': 'chat.openai.com',
    'perplexity': 'perplexity.ai', 'perplexity.ai': 'perplexity.ai',
    'claude': 'claude.ai', 'claude.ai': 'claude.ai',
    'gemini': 'gemini.google.com', 'gemini.google.com': 'gemini.google.com',
    'copilot': 'copilot.microsoft.com', 'copilot.microsoft.com': 'copilot.microsoft.com',
    'grok': 'grok.com', 'grok.com': 'grok.com',
    'mistral': 'chat.mistral.ai', 'chat.mistral.ai': 'chat.mistral.ai', 'lechat.mistral.ai': 'lechat.mistral.ai',
    'poe': 'poe.com', 'poe.com': 'poe.com', 'you.com': 'you.com'
  };
  function classify(referrer, url) {
    try {
      if (referrer) {
        const parsed = new URL(referrer);
        if (parsed.protocol === 'https:' && hosts.has(parsed.hostname.toLowerCase())) {
          return { host: parsed.hostname.toLowerCase(), evidence: 'referrer' };
        }
      }
      const source = new URL(url).searchParams.get('utm_source');
      const normalized = source && source.trim().toLowerCase();
      const host = normalized && Object.prototype.hasOwnProperty.call(sources, normalized) ? sources[normalized] : null;
      if (host) return { host, evidence: 'utm_source' };
    } catch (_) { /* Invalid input is not evidence. */ }
    return null;
  }
  const arrival = classify(document.referrer, window.location.href);
  let queue = Promise.resolve();
  let revoked = false;
  function permitted() {
    try { return !revoked && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function forget() { try { sessionStorage.removeItem(key); } catch (_) {} }
  function record() {
    if (!permitted()) { forget(); return null; }
    let saved = null;
    try {
      const raw = sessionStorage.getItem(key);
      if (raw) saved = JSON.parse(raw);
    } catch (_) {}
    const now = Date.now();
    if (arrival) {
      saved = { ...arrival, seenAt: now };
    } else if (!saved || !hosts.has(saved.host) || !['referrer', 'utm_source'].includes(saved.evidence) || !Number.isFinite(saved.seenAt) || saved.seenAt > now || now - saved.seenAt >= lifetime) {
      saved = null;
    }
    try { if (saved) sessionStorage.setItem(key, JSON.stringify(saved)); else sessionStorage.removeItem(key); } catch (_) {}
    return saved;
  }
  async function reconcile() {
    let visit = record();
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Kurvens kilde kunne ikke kontrolleres');
    const cart = await response.json();
    if (!permitted()) visit = null;
    const attributes = cart.attributes || {};
    const desired = visit ? {
      _ai_origin: 'AI_cit', _ai_referrer: visit.host,
      _ai_evidence: visit.evidence, _ai_seen_at: new Date(visit.seenAt).toISOString()
    } : { _ai_origin: '', _ai_referrer: '', _ai_evidence: '', _ai_seen_at: '' };
    const changes = {};
    for (const [name, value] of Object.entries(desired)) {
      if (String(attributes[name] || '') !== value) changes[name] = value;
    }
    // Existing source attributes are never changed, including haekberegner.
    if (!Object.keys(changes).length) return;
    const updated = await fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: changes })
    });
    if (!updated.ok) throw new Error('Kurvens kilde kunne ikke gemmes');
    const result = await updated.json();
    for (const [name, value] of Object.entries(changes)) {
      if (String(result.attributes?.[name] || '') !== value) throw new Error('Kurvens kilde blev ikke bekræftet');
    }
  }
  function sync() {
    queue = queue.catch(() => {}).then(reconcile).catch(error => {
      console.warn('[Nordicwoods attribution]', error.message);
    });
    return queue;
  }
  window.NordicwoodsAttribution = Object.freeze({ classify, sync, ready: () => queue });
  document.addEventListener('visitorConsentCollected', event => {
    revoked = event.detail?.analyticsAllowed === false;
    sync();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) sync(); });
  if (window.Shopify?.customerPrivacy) sync();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      if (!error) sync();
      else console.warn('[Nordicwoods attribution]', 'Samtykke kunne ikke kontrolleres');
    });
  }
})();
